import { styled } from "@vw-marketing/us-components";

export const StyledPinFormWrapper: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static350};
  width: 100%;

  // Hide the red icon in the input when the status is error
  & [class^='StyledDisplayTag-'],
  & [class*='StyledDisplayTag-'] {
    svg {
      display: none !important; 
    }
  }
`;